/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'crossroad': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M485.5 268v-24h26.24v-70.31h-173V.69H269V58h-25V.69h-70.26V148H244V81h25v92h-95.26v.69H.74v165h173v173H245V454h25v57.69h68.74V364H270v67h-25v-92h93.74v-.31h173V268zm-458 0H1v-24h26.5zm101.78 0H78.39v-24h50.89zm101.78 0h-50.89v-24h50.89zm101.77 0h-50.89v-24h50.89zm101.78 0h-50.89v-24h50.89z"/>'
  }
})
